import { useState } from "react";

export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      let item = null
      if(localStorage)
         item = localStorage.getItem(key);
      
      return item ? JSON.parse(item) : initialValue;
    } catch (err) {
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if(localStorage)
        localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (err) {
    }
  };

  return [storedValue, setValue];
};

export default useLocalStorage;